export type SupportedLocale = 'en-US' | 'es-ES' | 'de-DE' | 'fr-FR' | 'he';

export const supportedLocales: Record<string, SupportedLocale> = {
    en: 'en-US',
    es: 'es-ES',
    fr: 'fr-FR',
    de: 'de-DE',
    he: 'he',
} as const;
